import { FormattedMessage } from "react-intl";

import {
    SignupBackgroundLayout,
    TwcOverlayTemplate
} from "@/components/signup/layouts";
import SiteActivation from "@/components/signup/site-activation";
import { TeamworkCollectionLogo } from "@/components/signup/utils";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

import { CreateAWorkspaceHeading, SubHeading } from "../../components";

export const NewUser = () => {
    const twcSignupOverlayEnrolled = checkFeatureFlagGate(
        featureFlags.cfind5480TwcSignupOverlay
    );

    let content = (
        <SignupBackgroundLayout ProductLogo={<TeamworkCollectionLogo />}>
            <CreateAWorkspaceHeading />
            <SubHeading>
                <FormattedMessage
                    id="signup.serviceCollection.newUser"
                    defaultMessage="Workspaces are where people organize teams, work, and projects."
                />
            </SubHeading>
            <SiteActivation />
        </SignupBackgroundLayout>
    );

    if (twcSignupOverlayEnrolled) {
        content = (
            <TwcOverlayTemplate size="sm">
                <CreateAWorkspaceHeading />
                <SubHeading>
                    <FormattedMessage
                        id="signup.serviceCollection.newUser"
                        defaultMessage="Workspaces are where people organize teams, work, and projects."
                    />
                </SubHeading>
                <SiteActivation />
            </TwcOverlayTemplate>
        );
    }

    return content;
};
